export default {
	code: 'Kood',
	name: 'Oht',
	catalog: 'Kataloog',
	connectedRisks: 'Seotud riske',
	score: 'Riskitase',
	category: 'Kategooria',
	impact: 'Mõjuala',
	description: 'Kirjeldus',
	addName: 'Lisa ohu nimi',
	addCode: 'Lisa ohu kood',
	addDescription: 'Lisa ohu kirjeldus',
	addThreat: 'Lisa uus oht',
}
